import { useQuery } from 'react-query';

// Services
import { apiGetSeguros } from '../../../services/apis';

export function useGetSeguros() {
  return useQuery({
    queryKey: ['seguros'],
    queryFn: apiGetSeguros,
  });
}
